import { useState } from "react"
import "./FeedbackButton.css"

const INITIAL = { name: "", email: "", company: "", message: "" }

export default function FeedbackButton() {
  const [open, setOpen] = useState(false)
  const [form, setForm] = useState(INITIAL)
  const [status, setStatus] = useState("idle") // idle | sending | sent | error

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))

  async function submit(e) {
    e.preventDefault()
    setStatus("sending")
    try {
      const res = await fetch("/api/website/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      })
      if (!res.ok) {
        const d = await res.json().catch(() => ({}))
        throw new Error(d.detail || "Submission failed")
      }
      setStatus("sent")
      setForm(INITIAL)
      setTimeout(() => {
        setOpen(false)
        setStatus("idle")
      }, 2500)
    } catch (err) {
      setStatus("error")
    }
  }

  if (!open) {
    return (
      <button className="fb-trigger" onClick={() => setOpen(true)}>
        <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z"/></svg>
        Feedback
      </button>
    )
  }

  return (
    <div className="fb-overlay" onClick={(e) => e.target === e.currentTarget && setOpen(false)}>
      <div className="fb-modal">
        <button className="fb-close" onClick={() => setOpen(false)}>&times;</button>
        <h3>Send us feedback</h3>
        <form onSubmit={submit}>
          <div className="fb-field">
            <label>Name *</label>
            <input value={form.name} onChange={set("name")} required />
          </div>
          <div className="fb-field">
            <label>Email *</label>
            <input type="email" value={form.email} onChange={set("email")} required />
          </div>
          <div className="fb-field">
            <label>Company</label>
            <input value={form.company} onChange={set("company")} />
          </div>
          <div className="fb-field">
            <label>Message *</label>
            <textarea value={form.message} onChange={set("message")} required />
          </div>
          <button className="fb-submit" type="submit" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Send Feedback"}
          </button>
          {status === "sent" && <p className="fb-status fb-ok">Thank you! Your feedback has been sent.</p>}
          {status === "error" && <p className="fb-status fb-err">Something went wrong. Please try again.</p>}
        </form>
      </div>
    </div>
  )
}
